export default {
  featuredMovies: null,
  homeCarousel: null,
  movieList: null,
};
